import { render, staticRenderFns } from "./TeacherLeaveForm.vue?vue&type=template&id=a24568c8"
import script from "../../../controllers/common/teacher_leave/teacher-leave-form.js?vue&type=script&lang=js&external"
export * from "../../../controllers/common/teacher_leave/teacher-leave-form.js?vue&type=script&lang=js&external"
import style0 from "./TeacherLeaveForm.vue?vue&type=style&index=0&id=a24568c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports